<!--
  Implementation

  -in template:
    <date-li  :label="//string"
              :value="//string"
              :keyname="//string"
              :edit="//boolean"
              @fetch="updateValue">
    </date-li>
  
  -import:
    import DateLi from "@/components/ListItems/Editable/DateListItem.vue";

-->

<template>
  <slotted-edit-list-item :label="label"
                          :value="value"
                          :edit="edit"
                          :noempty="noempty"
                          :overrideDisplayValue="i18nEdit">
    <template v-slot:editmodecontent>
      <v-list-item-content class="pb-0">
        <v-text-field v-model="editValue"
                      ref="timefield"
                      background-color="white"
                      :rules="rule"
                      :label="noempty ? label + '*' : label"
                      hide-details="auto"
                      outlined
                      dense
                      class="field">
        </v-text-field>
      </v-list-item-content>
      <v-list-item-action class="my-0">
        <v-btn icon
               :class="[$refs['timefield'] && $refs['timefield'].hasError ? 'activeerror': '']"
               class="fieldbutton primary"
               @click="timetrigger++">
          <v-icon size="25"
                  color="#FFFFFF">mdi-clock</v-icon>
        </v-btn>
      </v-list-item-action>
      <time-picker-dialog :externalTrigger="timetrigger"
                          :onlypast="onlypast"
                          :onlyfuture="onlyfuture"
                          :inTime="vuetifyEdit"
                          @fetch="setEditValue">
      </time-picker-dialog>
    </template>
  </slotted-edit-list-item>
</template>



<script>
import rules from "@/helpers/Mixins/RuleMixin.js";
import SlottedEditListItem from "@/components/Inputs/Parts/SlottedEditListItem.vue";
import TimePickerDialog from "@/components/Dialogs/TimePickerDialog.vue";

export default {
  name: "EditListItem",
  props: ["label", "keyname", "value", "edit", "noempty", "onlyedit", "onlypast", "onlyfuture", "loading"],
  components: { SlottedEditListItem, TimePickerDialog },
  mixins: [rules],

  data() {
    return {
      editValue: null,
      timetrigger: 0,
    };
  },

  mounted() {
    this.parseTime();
    this.emitValue();
  },

  methods: {
    setEditValue(newval) {
      this.editValue = newval;
    },
    emitValue() {
      this.$emit("fetch", { key: this.keyname, value: this.oldFormatTime(this.editValue) });
    },

    parseTime() {
      this.editValue = this.i18nFormatTime(this.value);
    },
  },

  computed: {
    rule() {
      if (this.noempty) {
        return this.noEmptyRule;
      } else {
        return [];
      }
    },

    i18nEdit() {
      var val = this.i18nFormatTime(this.editValue);
      return val ? val : "Invalid or no time set";
    },

    vuetifyEdit(){
      return this.VuetifyFormatTime(this.editValue);
    }
  },

  watch: {
    value: function () {
      this.parseTime();
    },

    editValue: function () {
      //this.emitValue();
    },
  },
};
</script>

<style lang="scss" scoped>
.error--text {
  margin-bottom: -8px !important;
}
.field {
  background-color: transparent;
  z-index: 5;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.fieldbutton {
  border: 1px solid rgba($color: #000000, $alpha: 0.1);
  border-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 19px !important;
  padding-left: 28px !important;
  margin-left: -10px;
  margin-top: 12px;
  z-index: 1;
}
.fieldbutton.activeerror {
  margin-top: -7px;
}
.fieldbutton:hover {
  border: 1px solid rgb(55, 55, 55);
}
</style>